import React, { Component } from 'react'
// import { faCircle , faRunning } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SvgLogoNoSlogonBlack from '../SvgLogoNoSlogonBlack.js'

export default class TrainingZoneButton extends Component {
    render() {
        return (
            <button className={this.props.classNameProp} 
                onClick={() => this.props.onClick()}
            >
                <SvgLogoNoSlogonBlack fill={this.props.colorProps} width={"65px"} height={"50px"} />
                <br />
                {this.props.text}
            </button>
        );
    }
}